<!--
 * @Description: 单独添加
 * @Date: 2025-09-12 15:14:09
-->

<template>
  <BaseDialog
    width="960px"
    title="单独添加"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
  >
    <DetailLicense
      ref="ruleFormRef"
      type="add"
      :columnCount="2"
      v-model="formData"
    />
    <template #footer>
      <BaseButton @click="remove" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确定</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseButton,
  XrkMessage,
  BaseFormRef,
  BaseDialog
} from 'xrk-components';
import { addIndividual, addCheck } from '../data-source/apis';
import { AddIndividualParams } from '../data-source/types';
import { DetailLicense } from './detail';

const emits = defineEmits(['success']);
const props = withDefaults(defineProps<{ remove?: () => {} }>(), {});

const ruleFormRef = ref<BaseFormRef>();
const formData = ref<AddIndividualParams>({
  businessIndividualId: null,
  individualName: '',
  businessParkId: null,
  operator: '',
  phone: '',
  entpCertType: null,
  entpCertNo: '',
  entpCertPic: '',
  expiraStart: '',
  expiraEnd: '',
  enable: null,
  registerAt: '',
  declareMethod: null,
  taxAssessmentMethod: null,
  invoiceType: 3,
  invoiceItemIdList: [],
  individualType: null,
  _expira: [],
  _fileList: [],
  _invoiceType: [1, 2],
  parkType: null,
  isPermanent: 0
});
const onConfirm = async () => {
  await ruleFormRef.value.validate();
  const { data: addCheckData } = await addCheck({
    operator: formData.value.operator,
    phone: formData.value.phone
  });
  if (addCheckData.status === 1) {
    await addIndividual(formData.value);
    emits('success');
    props.remove();
  } else {
    XrkMessage.error('当前个体户不可新增');
  }
};
</script>
